import { DetailTable } from "./DetailTable";
import { useGeneralData } from "../hooks/useGeneralData";

export function General({ opportunityId }: { opportunityId?: string }) {
    const { generalData, identifiersData } = useGeneralData({ opportunityId });

    return (
        <div className="space-y-12">
            <DetailTable title="General" data={generalData} />
            <DetailTable title="Identifiers" data={identifiersData} />
        </div>
    );
}
